module.exports = __webpack_public_path__ + "static/media/sekiro.b520e09c.jpg";